define((require) => {
    "use strict";

    const ChunkingCollection              = require("data/ChunkingCollection");
    const ImageModel                      = require("ui/assets/image/ImageModel");
    const ImageLibrarySourceEnum          = require("shared/data/images/ImageLibrarySourceEnum");
    const SyncManager                     = require("shared/services/sync/SyncManager");
    const RestApi                         = require("shared/services/RestApi");
    const {GATEWAY_TIME_OUT, BAD_GATEWAY} = require("shared/util/HttpStatusCodes");

    /**
     * Status codes mapped to error messages used for Scene7 errors.
     *
     * @type Map.<Number, String>
     */
    const errorMessages = new Map();
    errorMessages.set(GATEWAY_TIME_OUT, "Timed out while trying to access your Adobe Scene7 account. Please try again or contact Adobe with questions regarding your Scene7 account.");
    errorMessages.set(BAD_GATEWAY, "Unable to access your Adobe Scene7 account. Please try again or contact Adobe with questions regarding your Scene7 account status.");

    /**
     * Represents a (chunking) collection of images, supporting "lazy loading".
     *
     * @see  ChunkingCollection
     * @class ImageCollection
     */
    const ImageCollection = ChunkingCollection.extend("ImageCollection", {

        source: ImageLibrarySourceEnum.CREATOR, // default to Creator

        model: ImageModel,

        /**
         * Set the source to a valid source item in <tt>ImageLibrarySourceEnum</tt>
         *
         * @see  ImageLibrarySourceEnum
         * @param ImageLibrarySourceEnum item
         */
        updateSource(source) {
            this.source = source;
            this.trigger("source:changed", source);
        },

        url(options = {}) {
            // Only allow Creator images (i.e. no sourceType) for project images
            if (options.project) {
                // projects/PROJECT_ID/images
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, options.project.get("id"), RestApi.Collections.IMAGES);
            }

            return RestApi.pathToCollection(ImageModel.resourceFromSource(this.source));
        },

        _handleError(error) {
            const {status} = error;

            // Handle custom error messages...
            if (this.source === ImageLibrarySourceEnum.SCENE7 && errorMessages.has(status)) {
                error.action = "reload";
                error.prefix = "";
                error.message = errorMessages.get(status);

                return "alert";
            }

            return this.__super();
        }

    }, {

        /**
         * Counts the total amount of (the logged in principal's) images
         * in the Creator image library (i.e. *not* 3rd party image library integrations such as Scene7)
         *
         * @param  {Object}         options Options set of options.
         * @param  {ProjectModel}   options.project A <tt>ProjectModel</tt> - for counting all project specific images.
         * @return {Promise}        A <tt>Promise</tt> that resolves with the total number of (the logged in principal's) images.
         */
        count(options) {
            let location = RestApi.Collections.IMAGES_COUNT;
            const project = options && options.project;

            if (project) {
                // projects/{ID}/images/count
                location = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.IMAGES_COUNT);
            }

            return SyncManager.get(location, SyncManager.target("ImageCollection.count"));
        }

    });

    return ImageCollection;
});



// WEBPACK FOOTER //
// ./src/editor/data/ImageCollection.js